// @ts-nocheck
/*
 * Port of hooks/useReleaseCenter.js (48L). BYTE-IDENTICAL.
 * Fetches list+stats+tags in parallel; exposes { releases, stats, tags,
 * loading, error, refetch, setReleases }. `refetch({silent:true})` skips
 * the loading flag so per-row optimistic actions don't flash a skeleton.
 */
import { useCallback, useEffect, useState } from 'react';
import {
  listReleases,
  getReleaseStats,
  getReleaseTags,
} from './releaseCenterService';

export default function useReleaseCenter() {
  const [releases, setReleases] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [tags, setTags] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  const fetchAll = useCallback(
    async ({ silent = false }: any = {}) => {
      if (!silent) setLoading(true);
      setError(null);
      try {
        const [list, statsData, tagsData]: any = await Promise.all([
          listReleases(),
          getReleaseStats(),
          getReleaseTags(),
        ]);
        setReleases(Array.isArray(list) ? list : list?.rows ?? []);
        setStats(statsData || null);
        setTags(Array.isArray(tagsData) ? tagsData : []);
      } catch (err: any) {
        // httpCall already toasts; keep a flag so the page can show an error state.
        setError(
          typeof err === 'string' ? err : err?.message || 'Failed to load',
        );
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return {
    releases,
    stats,
    tags,
    loading,
    error,
    refetch: fetchAll,
    setReleases,
  };
}
